import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import type { MiningLandSummary } from '../hooks/useMiningLands';

const LAND_TYPE_LABELS: Record<string, string> = {
  mining: 'Mining Land',
  business: 'Business Land',
  litland: 'Litland',
  litland2: 'Litland 2',
};

interface MiningLandCardProps {
  land: MiningLandSummary;
}

export function MiningLandCard({ land }: MiningLandCardProps) {
  const label = LAND_TYPE_LABELS[land.landType] ?? land.landType;

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-lg">{label}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-2 text-sm text-muted-foreground">
          <div>
            Dimensions: {land.xSize} x {land.ySize} x {land.zSize}
          </div>
          <div>Generation: {land.generation}</div>
          <div>Paid Reset: {land.paidReset ? 'Yes' : 'No'}</div>
          <div>Created: {new Date(land.createdAt).toLocaleDateString()}</div>
        </div>
      </CardContent>
    </Card>
  );
}
